<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  padding: 0 20px 20px 50px;
  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 10px solid #3399ff;
    font-size: 16px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    color: #666666;
    font-weight: 700;
    padding-left: 15px;
  }
  .content_box {
    box-sizing: border-box;
    margin-top: 20px;
    width: 100%;
  }
  // .el-table__body{
  //   width: 100%!important;
  // }
}
</style>
<template>
  <div class="box">
<!--    <p class="page_title">安全检查</p>-->
    <div
      class=""
      style="padding-left: 10px; padding-top: 10px; background-color: #fff; position: relative"
      element-loading-text="正在查询,请稍候..."
    >
<!--      <el-tabs v-model="activeTabName" @tab-click="handleTabClick">-->
<!--        <el-tab-pane label="全部检查" name="0" v-if="hasPermission('22001101')"></el-tab-pane>-->
<!--        <el-tab-pane label="我创建的" name="1" v-if="hasPermission('22001102')"></el-tab-pane>-->
<!--        <el-tab-pane label="我需整改" name="2" ></el-tab-pane>-->
<!--      </el-tabs>-->
<!--      <el-button style="position: absolute; right: 2px; top: 16px;" type="primary" @click="showAddDialog(null)">添加</el-button>-->
      <div class="">
        <el-form :model="form" ref="form" label-position="100px" size="mini" inline="true" style="" >
          <el-form-item label="姓名" prop="checkDepartment">
            <el-input v-model="form.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="checkDepartment">
            <el-input v-model="form.phone" clearable></el-input>
          </el-form-item>
          <el-form-item label="车牌号" prop="checkDepartment">
            <el-input v-model="form.cph" clearable></el-input>
          </el-form-item>
          <el-form-item label="审核状态" prop="checkWay" >
            <el-select v-model="form.auditStatus" placeholder="" clearable >
              <el-option label="全部" value=""></el-option>
              <el-option label="待提交" value="-1"></el-option>
              <el-option label="待审核" value="0"></el-option>
              <el-option label="通过" value="1"></el-option>
              <el-option label="驳回" value="2"></el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="访问时间" prop="reportTime">-->
<!--            <el-date-picker-->
<!--                    v-model="form.accessTime"-->
<!--                    type="daterange"-->
<!--                    range-separator="至"-->
<!--                    start-placeholder="开始日期"-->
<!--                    end-placeholder="结束日期"-->
<!--                    value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                    clearable-->
<!--            >-->
<!--            </el-date-picker>-->
<!--          </el-form-item>-->
          <el-button type="primary" @click="fetchData">查询</el-button>
          <el-button @click="reset">重置</el-button>
<!--          <el-button type="primary" @click="showSetDialog()">访客申请设置项</el-button>-->
          <el-button type="primary" @click="showAddDialog(null)">添加人员</el-button>
<!--          <el-button type="primary" @click="showAuditDialog(null)">审核</el-button>-->
          <el-dropdown style="margin-left: 12px">
            <el-button type="primary">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="batchSubmit()">批量提交</el-dropdown-item>
<!--              <el-dropdown-item @click.native="importPhotoDialogVisible = true">批量审核</el-dropdown-item>-->
<!--              <el-dropdown-item @click.native="showBatchUpDialog()">批量修改</el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown style="margin-left: 12px">
            <el-button type="primary">
              导入<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="importExcelDialogVisible = true">导入申请记录</el-dropdown-item>
              <el-dropdown-item @click.native="importPhotoDialogVisible = true">导入人脸</el-dropdown-item>
              <el-dropdown-item @click.native="importCertificateDialogVisible = true">导入无犯罪记录证明</el-dropdown-item>
              <el-dropdown-item @click.native="importContractDialogVisible = true">导入聘用合同</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown style="margin-left: 12px">
            <el-button type="primary">
              导出<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="exportExcel">导出当前筛选记录</el-dropdown-item>
              <el-dropdown-item @click.native="exportPhoto">导出人脸</el-dropdown-item>
              <el-dropdown-item @click.native="exportCertificate">导出无犯罪记录证明</el-dropdown-item>
              <el-dropdown-item @click.native="exportContract">导出聘用合同</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form>
      </div>
      <div class="table_box" style="padding-right: 10px">
        <el-table
                :data="data"
                border
                fit
                highlight-current-row
                :height="tableHeight"
                ref="table"
                size="mini"
                style="margin-top: 0px;">
          <el-table-column type="selection" width="55"/>
          <el-table-column label="姓名" prop="name" width="105"/>
          <el-table-column label="校区" prop="campus" width=""/>
          <el-table-column label="所属部门" prop="departmentName" width=""/>
          <el-table-column label="人员类型" prop="type" width="95" >
            <template slot-scope="{row}">
              <sp v-if="row.type === 0" >教职工</sp>
              <sp v-if="row.type === 1" >学生</sp>
              <sp v-if="row.type === 2" >服务人员</sp>
              <sp v-if="row.type === 3" >其他</sp>
            </template>
          </el-table-column>
          <el-table-column label="证件号" prop="identityId" width="150"/>
          <el-table-column label="手机号" prop="phone"/>
          <el-table-column label="车牌号" prop="cph"/>
          <el-table-column label="通行开始时间" prop="accessStartTime"/>
          <el-table-column label="通行结束时间" prop="accessEndTime"/>
          <el-table-column label="权限状态" prop="accessPermission" width="95" >
            <template slot-scope="{row}">
              <el-tag v-if="row.accessPermission === true" type="success">生效</el-tag>
              <el-tag v-if="row.accessPermission === false" type="danger">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="人脸图片" prop="photoPath" width="100">
            <template slot-scope="scope">
              <el-image
                  v-if="scope.row.photoPath!=null && scope.row.photoPath!==''"
                  v-for="(item, index) in getImageUrls(scope.row)"
                  :key="index"
                  :src="getImagePath(item)"
                  :preview-src-list="[getImagePath(item)]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" prop="auditStatus" width="95" >
            <template slot-scope="{row}">
              <el-tag v-if="row.auditStatus == -1" type="warning">待提交</el-tag>
              <el-tag v-if="row.auditStatus == 0" type="info">待审核</el-tag>
              <el-tag v-if="row.auditStatus == 1" type="success">通过</el-tag>
              <el-tag v-if="row.auditStatus == 2" type="danger">拒绝</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否可通行" prop="isAccess">
            <template slot-scope="{row}">
              <el-tag v-if="row.isAccess === true" type="success">允许通行</el-tag>
              <el-tag v-if="row.isAccess === false" type="danger">禁止通行</el-tag>
            </template>
          </el-table-column>
<!--          <el-table-column label="到访状态" prop="visStatus" width="95" >-->
<!--            <template slot-scope="{row}">-->
<!--              <el-tag v-if="row.visStatus === 0" type="info">未到访</el-tag>-->
<!--              <el-tag v-if="row.visStatus === 1" type="success">已到访</el-tag>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
<!--              <el-button v-if="scope.row.auditStatus !== 0" type="text" size="mini" @click="showUpdateDialog(scope.row)" >详情</el-button>-->
              <el-button type="text" size="mini" @click="showUpdateDialog(scope.row)" >详情</el-button>
<!--              <el-button type="text" size="mini" @click="showAuditDialog(scope.row)" >审核</el-button>-->
<!--              <el-button v-if="scope.row.accessPermission === true" type="text" style="color: #E6A23C" size="mini" @click="upConfigStatus(scope.row)" >禁止通行</el-button>-->
<!--              <el-button v-if="scope.row.accessPermission === false" type="text" size="mini" @click="upConfigStatus(scope.row)" >允许通行</el-button>-->
<!--              <el-button type="text" size="mini" @click="remove(scope.row)" style="color: #f12">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageInfo.current"
                :page-sizes="[15, 50, 100, 200]"
                :page-size="pageInfo.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageInfo.total"
                style="text-align: right; margin-top: 10px;"/>
      </div>
    </div>
    <el-dialog title="添加" :visible.sync="addDialogVisible" v-if="addDialogVisible" width="1000px" top="0" @close="onAuditDialogClose">
      <add-view :form="editForm" ref="addForm" @closeDialog="closeDialogClose"></add-view>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" v-if="detailDialogVisible" width="1000px" top="0" @close="onAuditDialogClose">
      <detail  :form="showDetailForm"></detail>
    </el-dialog>

    <el-dialog :visible.sync="importExcelDialogVisible" title="导入人员入库信息" top="1vh" width="500px">
      <el-upload
          class="upload-demo"
          drag
          :action="importExcelUrl"
          :headers="fileUploadHeaders"
          :on-success="onUploadSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          multiple
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">
          只能上传xls/xlsx文件，且不超过500kb.
          <br>
          <br>
          <span style="color: #F56C6C">请确保按导出模板导入，否则会导入失败！</span>
          <br>
          <el-button type="text" @click="downloadImportExcelModule">点击这里</el-button>下载导入模板
        </div>

      </el-upload>
    </el-dialog>

    <el-dialog :visible.sync="importPhotoDialogVisible" title="导入人脸（身份证号命名）" top="1vh" width="500px">
      <el-upload
          class="upload-demo"
          drag
          :action="importPhotoUrl"
          :headers="fileUploadHeaders"
          :on-success="onUploadPhotoSuccess"
          :before-upload="beforeUpload"
          :file-list="filePhotoList"
          multiple
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">
          只能上传zip文件.
          <br>
          <br>
          <span style="color: #F56C6C">请确保图片按照身份证号命名，否则会导入失败！</span>
        </div>
      </el-upload>
    </el-dialog>

    <el-dialog :visible.sync="importCertificateDialogVisible" title="导入无犯罪记录证明（身份证号命名）" top="1vh" width="500px">
      <el-upload
          class="upload-demo"
          drag
          :action="importCertificateUrl"
          :headers="fileUploadHeaders"
          :on-success="onUploadCertificateSuccess"
          :before-upload="beforeUpload"
          multiple
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">
          只能上传zip文件.
          <br>
          <br>
          <span style="color: #F56C6C">请确保图片按照身份证号命名，否则会导入失败！</span>
        </div>
      </el-upload>
    </el-dialog>

    <el-dialog :visible.sync="importContractDialogVisible" title="导入聘用合同（身份证号命名）" top="1vh" width="500px">
      <el-upload
          class="upload-demo"
          drag
          :action="importContractUrl"
          :headers="fileUploadHeaders"
          :on-success="onUploadContractSuccess"
          :before-upload="beforeUpload"
          multiple
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">
          只能上传zip文件.
          <br>
          <br>
          <span style="color: #F56C6C">请确保图片按照身份证号命名，否则会导入失败！</span>
        </div>
      </el-upload>
    </el-dialog>

    <el-dialog :visible.sync="batchUpDialogVisible" title="批量修改权限时间" top="1vh" width="1000px">
      <el-form ref="addStaffForm" :model="batchForm" label-width="150px" style="max-height: 80vh; overflow-y: scroll; overflow-x: hidden; padding-right: 20px;" size="mini">
        <el-form-item label="通行有效期" required>
          <el-date-picker
              v-model="accessTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
              :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 0; margin-top: 15px;">
        <el-button type="text" @click="batchUpDialogVisible = false">取消</el-button>
        <el-button type="primary" size="" @click="batchUp()">提交修改并进入审核</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="auditDialogVisible" title="访客申请审核" top="1vh" width="1000px">
      <el-form ref="addStaffForm" :model="auditForm" label-width="150px" style="max-height: 80vh; overflow-y: scroll; overflow-x: hidden; padding-right: 20px;" size="mini">
        <el-form-item label="审核结果" required>
          <el-radio-group v-model="auditForm.auditStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" v-model="auditForm.auditRemark" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 0; margin-top: 15px;">
        <el-button type="text" @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" size="" @click="audit()">提交审核结果</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="visitSetDialogVisible" title="访客设置" top="1vh" width="1000px">
      <el-form ref="addStaffForm" :model="visitSetForm" label-width="150px" style="max-height: 80vh; overflow-y: scroll; overflow-x: hidden; padding-right: 20px;" size="mini">
        <el-form-item label="最大提前预约天数" required>
          <el-input-number v-model="visitSetForm.maxAppointmentDay" @change="handleChange" :min="-1" :max="30" label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item label="最长访问天数" required>
          <el-input-number v-model="visitSetForm.maxVisitDay" @change="handleChange" :min="1" :max="30" label="描述文字"></el-input-number>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 0; margin-top: 15px;">
        <el-button type="text" @click="visitSetDialogVisible = false">取消</el-button>
        <el-button type="primary" size="" @click="visitSet()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/apiRequest'
import Detail from "./Detail";
import AddView from "./AddView";
import {hasPermission} from "@/utils/hasPermission"


export default {
  mixins: [],
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      showClass: true,
      fileList:[],
      filePhotoList:[],
      recordIds:[],
      ids:'',
      form: {
        name: '',
      },
      fileUploadHeaders: {
        "Authorization": 'bearer ' + sessionStorage.getItem("access_token")
      },
      tabPermission: [],
      data: [],
      pageInfo: {
        current: 1,
        size: 15,
        total: 0
      },
      activeTabName: null,
      detailDialogVisible: false,
      showDetailForm: {
        campusList: [],
        accessTime: [],
      },
      auditForm: {},
      auditDialogVisible: false,
      visitSetForm: {
        maxAppointmentDay:-1,
        maxVisitDay:''
      },
      visitSetDialogVisible: false,
      selectedHiddenDangerRecordId: -1,
      hideAuditForm: false,
      addDialogVisible: false,
      zgDialogVisible: false,
      urlContext: process.env.VUE_APP_BASE_API,
      editForm: {
      },
      batchForm: {
        ids:'',
        auditStatus:0,
        auditRemark:0,
        accessStartTime:null,
        accessEndTime:null,
      },
      accessTime:[],
      batchUpDialogVisible: false,
      //导入
      importExcelDialogVisible: false,
      importPhotoDialogVisible: false,
      importCertificateDialogVisible: false,
      importContractDialogVisible: false,
      importExcelUrl: process.env.VUE_APP_BASE_API + '/user/commonUserRequest/importExcel',
      importPhotoUrl: process.env.VUE_APP_BASE_API + '/user/commonUserRequest/importPicZip',
      importCertificateUrl: process.env.VUE_APP_BASE_API + '/user/commonUserRequest/importCertificateZip',
      importContractUrl: process.env.VUE_APP_BASE_API + '/user/commonUserRequest/importContractZip',
      //导出

    };
  },
  mounted(){
    this.fetchData()
  },
  methods: {
    getImageUrls(row) {
      // 返回缩略图文件名数组
      if(row.photoPath==null){
        return null
      }
      return row.photoPath.split(',');
    },
    getImagePath(filename) {
      return this.urlContext + '/user' + filename; // 拼接完整的图片路径
    },
    buildQueryForm() {
      const queryForm = {...this.form, ...this.pageInfo}
      // if (queryForm.accessTime != null && queryForm.accessTime.length == 2) {
      //   queryForm.accessStartTime = queryForm.accessTime[0]
      //   queryForm.accessEndTime = queryForm.accessTime[1]
      // }
      // delete queryForm.accessTime
      delete queryForm.total
      return queryForm
    },
    fetchData() {
      const queryForm = this.buildQueryForm()
      request({
        url: '/user/commonUserRequest/listByPage',
        params: queryForm,
        method: 'get'
      }).then(res => {
        this.data = res.data.records
        this.pageInfo.current = res.data.current
        this.pageInfo.size = res.data.size
        this.pageInfo.total = res.data.total
      })
    },
    // 展示访客设置
    showSetDialog() {
      request({
        url: '/user/systemConfig/detail',
        method: 'get',
        loading: true
      }).then(response => {
        this.visitSetForm = response.data
        this.visitSetDialogVisible = true
      })
    },
    visitSet() {
      request({
        url: '/user/systemConfig/setVisitConfig',
        method: 'post',
        data: this.visitSetForm,
        loading: true
      }).then(response => {
        this.$message.success('操作成功')
        // this.fetchData()
        this.visitSetForm = {}
        this.visitSetDialogVisible = false
      })
    },
    // 展示添加弹框
    showAddDialog() {
      this.editForm = {}
      this.addDialogVisible = true
    },
    closeDialogClose() {
      this.addDialogVisible = false
      this.fetchData()
    },
    // 展示编辑弹框
    showUpdateDialog(editData) {
      this.showDetailForm = editData
      request({
        url: '/user/commonUserRequest/detail?id=' + editData.id,
        method: 'get',
        loading: true
      }).then(response => {
        this.showDetailForm = response.data
        // if(this.showDetailForm.accessStartTime!=null){
        //   this.showDetailForm.accessTime=[this.showDetailForm.accessStartTime,this.showDetailForm.accessEndTime]
        // }
        this.detailDialogVisible = true
      })
    },
    //设置通行状态
    upConfigStatus(editData) {
      request({
        url: '/user/commonUserRequest/upConfigStatus?id=' + editData.id,
        method: 'get',
        loading: true
      }).then(response => {
        this.fetchData()
      })
    },
    batchSubmit(callback) {
      this.recordIds = []
      const selected = this.$refs.table.selection
      for (const record of selected) {
        this.recordIds.push(record.id)
      }
      if (this.recordIds == 0) {
        this.$message.error('请选择项目！')
        return
      }
      this.ids = this.recordIds.join(',')
      request({
        url: '/user/commonUserRequest/batchSubmit?ids=' + this.ids,
        method: 'get',
        loading: true
      }).then(response => {
        this.fetchData()
        this.ids =''
      })
    },
    // 展示审核弹框
    showBatchUpDialog(editData) {
      this.recordIds = []
      const selected = this.$refs.table.selection
      for (const record of selected) {
        this.recordIds.push(record.id)
      }
      if (this.recordIds == 0) {
        this.$message.error('请选择项目！')
        return
      }
      this.ids = this.recordIds.join(',')
      this.batchForm.ids = this.ids
      this.batchUpDialogVisible = true
    },
    // 审核
    batchUp() {
      if (this.accessTime != null && this.accessTime.length === 2) {
        this.batchForm.accessStartTime = this.accessTime[0]+' 00:00:00'
        this.batchForm.accessEndTime = this.accessTime[1]+' 23:59:59'
      }else {
        this.$message.error('通行有效期不为空！')
        return
      }
      request({
        url: '/user/commonUserRequest/batchUpdate',
        method: 'post',
        data: this.batchForm,
        loading: true
      }).then(response => {
        this.$message.success('操作成功')
        this.batchUpDialogVisible = false
        this.fetchData()
        this.batchForm = {}
        this.accessTime=[]
      })
    },
    // 展示审核弹框
    showAuditDialog(editData) {
      this.auditForm.visitingRequestId = editData.id
      this.auditDialogVisible = true
    },
    // 审核
    audit() {
      if (this.auditForm.visitingRequestId == null) {
        this.$message.error('申请ID不为空！')
        return
      }
      if (this.auditForm.auditStatus == null) {
        this.$message.error('审核状态不为空！')
        return
      }
      if (this.auditForm.status === 2) {
        if (this.auditForm.remark == null) {
          this.$message.error('请填写审核意见！')
          return
        }
      }
      request({
        url: '/user/visitingRequest/auditRequest',
        method: 'post',
        data: this.auditForm,
        loading: true
      }).then(response => {
        this.$message.success('操作成功')
        this.fetchData()
        this.auditForm = {}
      })
    },
    //启用
    start(row) {
      request({
        url: '/user/patrolPoint/start',
        params: {
          id: row.id
        },
        method: 'get',
        loading: true
      }).then(res => {
        this.$message.success('操作成功')
        this.fetchData()
      })
    },
    //停用
    end(row) {
      request({
        url: '/user/patrolPoint/end',
        params: {
          id: row.id
        },
        method: 'get',
        loading: true
      }).then(res => {
        this.$message.success('操作成功')
        this.fetchData()
      })
    },
    // 下载导入模板
    downloadImportExcelModule() {
      window.location.href = process.env.BASE_URL + '人员入库申请模板.xls'
    },
    // 人员入库申请导入回调
    onUploadSuccess(response) {
      if (response.code === 20000) {
        this.$message.success('操作成功')
        this.importExcelDialogVisible = false
        this.fetchData()
        this.fileList=[]
      } else {
        this.$message.error(response.message)
      }
      this.$loading().close()
    },
    // 人脸导入回调
    onUploadPhotoSuccess(response) {
      this.filePhotoList = []
      if (response.code === 20000) {
        this.$message.success('操作成功')
        this.importPhotoDialogVisible = false
        this.fetchData()
      } else {
        this.$message.error(response.message)
      }
      this.$loading().close()
    },
    // 无犯罪记录证明导入回调
    onUploadCertificateSuccess(response) {
      if (response.code === 20000) {
        this.$message.success('操作成功')
        this.importCertificateDialogVisible = false
        this.fetchData()
      } else {
        this.$message.error(response.message)
      }
      this.$loading().close()
    },
    // 聘用合同导入回调
    onUploadContractSuccess(response) {
      if (response.code === 20000) {
        this.$message.success('操作成功')
        this.importContractDialogVisible = false
        this.fetchData()
      } else {
        this.$message.error(response.message)
      }
      this.$loading().close()
    },
    // 导入前
    beforeUpload() {
      this.$loading()
    },
    // 导出excel
    exportExcel() {
      const queryForm = this.buildQueryForm()
      request({
        url: '/user/commonUserRequest/exportData',
        params: queryForm,
        method: 'get',
        responseType: 'blob',
        loading: true
      })
    },
    // 导出excel
    exportPhoto() {
      const queryForm = this.buildQueryForm()
      request({
        url: '/user/commonUserRequest/exportPicZip',
        params: queryForm,
        method: 'get',
        responseType: 'blob',
        loading: true
      })
    },
    // 导出照片
    exportCertificate() {
      const queryForm = this.buildQueryForm()
      request({
        url: '/user/commonUserRequest/exportCertificateZip',
        params: queryForm,
        method: 'get',
        responseType: 'blob',
        loading: true
      })
    },
    // 导出照片
    exportContract() {
      const queryForm = this.buildQueryForm()
      request({
        url: '/user/commonUserRequest/exportContractZip',
        params: queryForm,
        method: 'get',
        responseType: 'blob',
        loading: true
      })
    },
    // 删除记录
    remove(row) {
      this.$confirm('是否删除当前记录？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/user/commonUserRequest/deleteById',
          params: {
            id: row.id
          },
          method: 'get',
          loading: true
        }).then(res => {
          this.$message.success('操作成功')
          this.fetchData()
        })
      });
    },
    handleTabClick(tab, event) {
      this.activeTabName = tab.name
      this.fetchData()
    },
    reset() {
      this.$refs.form.resetFields();
      this.form={}
      this.fetchData()
    },
    onAuditDialogClose() {
      this.fetchData()
    },
    // 修改每页最大数量
    handleSizeChange(size) {
      this.pageInfo.size = size
      this.fetchData()
    },
    // 翻页
    handleCurrentChange(current) {
      this.pageInfo.current = current
      this.fetchData()
    },
    // showAudit(row) {
    //   this.selectedHiddenDangerRecordId = row.id
    //   // 已审核的，隐藏审核表单
    //   if (row.auditStatus == 1) {
    //     this.hideAuditForm = true
    //   } else {
    //     this.hideAuditForm = false
    //   }
    //   this.auditDialogVisible = true
    // },
    // hasPermission(id) {
    //   return hasPermission(id)
    // }
  },
  components: {
    AddView,
    Detail

  }

};
</script>

